import { useParams } from 'react-router-dom';
import React from 'react';
import useSWR from 'swr';
import { Box } from 'rebass';
import ResponsiveReactPlayer from 'story-media/medium-types/ResponsiveReactPlayer';
import Loading from 'story-pages/list/loading';

const PublicMedia = () => {
  const { id } = useParams();
  const { data } = useSWR(id ? `v2/media/${id}` : null)
  const videoData = data?.data?.data

  const video = videoData?.type === "videos" ? videoData?.attributes : null;
  const audio = videoData?.type === "audios" ? videoData?.attributes : null;
  let url = null

  if (!!video) {
    if (video.landscape)
      url = video?.['hls-landscape'] || video?.['asset-url'];
    else if (video.portrait)
      url = video?.['hls-portrait'] || video?.['asset-url'];
  }
  else if (!!audio) {
    url = audio?.['asset-url'];
  }

  if (!video && !audio) {
    return <Box css="width: 100%; position: absolute;top: 0; height: 100vh; left: 0; padding-top: 40vh; background-color: rgba(255, 255, 255, 0.5);">
      <Loading local />
    </Box>
  }

  return <Box sx={{ position: 'fixed', top: 0, height: '100vh', width: '100vw' }}>
    <ResponsiveReactPlayer
      url={url}
      preload={true}
      playing={true}      // this triggers autoplay
      controls={true}
      height={!!audio ? '50%' : "100%"}
      playerWrapper={{ height: 'inherit' }}
      style={{
        borderRadius: '10px',
        transformOrigin: 'center',
      }}
    />
  </Box>

};

export default PublicMedia;
